import { Link } from "react-router-dom";
import PageBanner from "../../PageBanner";
import SocialMediaSidebar from "../../SocialMediaSidebar";
import SectionHeader from "../../SectionHeader";
import ScrollToTopButton from "../../ScrollToTopButton";
import cc from "../../../assets/images/cc.png";

const OfferingParkingAlert = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Dynamic Information Display"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "Offerings" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeader
          title="Dynamic Information Display @ AJEEVI"
          shareUrl="https://swmecom.ajeevi.in/data-insights"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Summary Section */}
          <div className="flex flex-col md:flex-row items-center md:items-start gap-8 mb-10">
            {/* Text Section */}
            <div className="md:w-1/2">
              <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
                Summary
              </h4>
              <p className="text-black mb-4 text-lg">
                Variable Message Display (VMD) screens are key to real-time, dynamic communication across urban spaces. They provide instant updates, traffic alerts, safety messages, and emergency broadcasts, keeping citizens informed and responsive.
              </p>
              <p className="text-black text-lg">
                These systems enhance public engagement by broadcasting timely and location-specific information, ensuring that urban mobility and safety are always a priority.
              </p>
            </div>

            {/* Image Section */}
            <div className="md:w-1/2">
              <img
                src={cc}
                alt="Dynamic Information Display"
                className="w-full h-auto rounded-lg shadow-md"
              />
            </div>
          </div>

          {/* Introduction Section */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Introduction
            </h4>
            <p className="text-black mb-4 text-lg">
              Dynamic Information Display solutions empower cities with real-time content delivery through electronic signage. Using VMDs placed at strategic locations, city authorities can instantly inform citizens about traffic conditions, diversions, weather updates, and emergencies.
            </p>
            <p className="text-black text-lg">
              These systems improve transparency, responsiveness, and public safety, especially in high-density areas like highways, intersections, and public transport hubs.
            </p>
          </div>

          {/* Key Features Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-4 text-black">
              Key Features of Dynamic Information Display:
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black">
              <li><strong>Real-time Updates:</strong> Deliver instant information for traffic, alerts, and guidance</li>
              <li><strong>Remote Content Management:</strong> Update messages from a centralized control room</li>
              <li><strong>Weather & Emergency Alerts:</strong> Broadcast high-priority information without delay</li>
              <li><strong>Energy-Efficient Displays:</strong> Long-lasting and visible in all lighting conditions</li>
              <li><strong>Multi-Language Support:</strong> Serve diverse populations with inclusive communication</li>
              <li><strong>Integration with City Systems:</strong> Pull data from traffic sensors, weather APIs, and more</li>
            </ul>
          </div>

          {/* Operational Benefits Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Operational Benefits
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Improved traffic flow through early warnings and route suggestions</li>
              <li>Greater citizen awareness during emergencies or planned events</li>
              <li>Lower communication costs compared to manual outreach</li>
              <li>Increased safety through timely hazard notifications</li>
              <li>Centralized and automated display control</li>
              <li>Enhanced public trust through transparent city communication</li>
            </ul>
          </div>

          {/* Implementation Considerations */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Implementation Considerations
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Strategic placement of VMD units for maximum visibility</li>
              <li>Reliable power and connectivity to avoid message disruptions</li>
              <li>Regular testing and calibration for accurate content display</li>
              <li>Integration with backend data sources and APIs</li>
              <li>Protection against vandalism and weather damage</li>
              <li>Scalable setup for city-wide or region-wide deployment</li>
            </ul>
          </div>

          {/* Ajeevi's Contribution Section */}
          <div>
            <h5 className="text-xl font-semibold mb-3 text-black">
              Ajeevi's Dynamic Display Solutions
            </h5>
            <p className="text-black mb-4 text-lg">
              Ajeevi delivers end-to-end Dynamic Information Display systems tailored for urban environments:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li><strong>High-Visibility VMD Screens:</strong> Clear, legible displays for day and night</li>
              <li><strong>Smart Content Scheduling:</strong> Set messages based on time, location, or condition</li>
              <li><strong>Real-Time Connectivity:</strong> Integrated with traffic, weather, and emergency systems</li>
              <li><strong>Centralized Dashboard:</strong> Manage all displays from a single platform</li>
              <li><strong>End-to-End Support:</strong> Installation, maintenance, and training services</li>
            </ul>
            <p className="text-black text-lg">
              Discover how Ajeevi’s Dynamic Information Display systems can keep your city informed and safe. Visit{" "}
              <a
                href="http://www.ajeevi.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#00D084] hover:underline"
              >
                www.ajeevi.com
              </a>{" "}
              for more information.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferingParkingAlert;
